export const menuItems: any = [
  {
    label: 'TROJAN',
    isHeader: true,
  },
  {
    id: 'clients',
    label: 'SideBar.sideBar.clients',
    icon: 'ri-building-3-line',
    link: '/client-dashboard',
  },
  {
    id: 'users',
    label: 'SideBar.sideBar.users',
    icon: 'ri-user-3-line',
    link: '/users/',
  },
  {
    id: 'trapsAndHubs',
    label: 'SideBar.sideBar.trapsAndHubs',
    icon: 'ri-router-line',
    link: '/trap-warehouse',
  },
  // {
  //   id: 'calendar',
  //   label: 'SideBar.sideBar.calendar',
  //   icon: 'ri-calendar-2-line',
  //   link: `${process.env.REACT_APP_BASE_DJANGO_URL}/task_calendar/`,
  // },
  // {
  //   id: 'documentManagement',
  //   label: 'SideBar.sideBar.documentManagement',
  //   icon: 'ri-file-shield-2-line',
  //   link: `${process.env.REACT_APP_BASE_DJANGO_URL}/contract_list/`,
  // },
  // {
  //   id: 'visits',
  //   label: 'SideBar.sideBar.visits',
  //   icon: 'ri-inbox-unarchive-line',
  //   link: `${process.env.REACT_APP_BASE_DJANGO_URL}/visits_report_full_list/`,
  // },
  // {
  //   id: 'myCompany',
  //   label: 'SideBar.sideBar.myCompany',
  //   icon: 'ri-government-line',
  //   link: '/service-provider',
  // },
  // {
  //   id: 'finances',
  //   label: 'SideBar.sideBar.finances',
  //   icon: 'ri-refund-2-line',
  //   link: `${process.env.REACT_APP_BASE_DJANGO_URL}/finances/tariffs/`,
  // },
  // {
  //   id: 'analytics',
  //   label: 'SideBar.sideBar.analytics',
  //   icon: 'ri-bar-chart-2-line',
  //   link: `${process.env.REACT_APP_BASE_DJANGO_URL}/api/analitycs/analytics/`,
  // },
  // {
  //   id: 'educationalPlatform',
  //   label: 'SideBar.sideBar.educationalPlatform',
  //   icon: 'ri-team-line',
  //   link: 'https://school.trojan.systems/',
  // },
];
